<template>
  <div class="mso-groups responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'msoGroups', label: 'MSO Group' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "msoGroups",
  data() {
    return {
      listPageHeader,
      entity: Entities.MSOGROUP,
    };
  },
  mounted: function () {
    this.setPageTitle("MSOGroups");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "msoGroupModule/sort",
      pagination: "msoGroupModule/pagination",
      initialFilter: "msoGroupModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "msoGroupModule/updateSort",
      updatePagination: "msoGroupModule/updatePagination",
      updateInitialFilter: "msoGroupModule/updateInitialFilter"
    }),
  }
};
</script>
